import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';

export default function Layout({ darkMode }) {
  return (
    <div className={`${darkMode ? 'cs_dark' : ''}`}>
      <Header
        logoUrl={darkMode ? '/images/favicon.png' : '/images/favicon.png'}
        actionBtnText="Contact"
        actionBtnUrl="https://discord.gg/upbs5Unb5n" // Discord invite link
      />
      <Outlet />
      <Footer />
    </div>
  );
}
